import React from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';

import type { CheckboxFieldProps } from './interface';

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  label = '',
  input,
  labelClassName,
  formControlLabelProps = {},
  ...rest
}) => {
  const { name, value, onBlur, onChange } = input;

  const handleChange = React.useCallback(
    (_event: React.ChangeEvent, checked: boolean) => {
      onChange(checked);
    },
    [onChange],
  );

  return (
    <FormControlLabel
      {...formControlLabelProps}
      label={label}
      classes={{
        label: labelClassName,
      }}
      control={
        <Checkbox
          name={name}
          checked={Boolean(value)}
          onChange={handleChange}
          onBlur={onBlur}
          {...rest}
        />
      }
    />
  );
};
